import { V1AuthLogin, V1AuthTerminal } from '../v1/auth/auth.model';
import { ATTENDANCE_EVENT_STATUS } from '../v1/module-attendance-v2/attendance-v2-overview';

export enum TERMINAL_V2_TEXT_INFO_TYPE {
  ERROR = 'danger',
  SUCCESS = 'success',
}

export enum ATTENDANCE_DEVICE_TYPE_FOR_AUDIT {
  MOBILE = 'mobile',
  WEB = 'web',
  TERMINAL = 'terminal',
}

export enum TERMINAL_V2_ATTENDANCE_TYPE {
  IN_WORK = 'in_work',
  ABSENCE = 'absence',
  BREAK = 'break',
  HOME_OFFICE = 'home_office',
  BUSINESS_TRIP = 'business_trip',
  OUT_OF_WORK = 'out_of_work',
}

export const TERMINAL_V2_LANGUAGE_PAGE_DURATION_MS = 15000;
export const TERMINAL_V2_NOTIFICATION_RESET_DURATION_MS = 5000;
export const TERMINAL_V2_USER_LOGOUT_PAGE_DURATION_MS = 15000;
export const TERMINAL_V2_CAMERA_STREAM_DURATION_MS = 15000;
export const TERMINAL_V2_LOCK_OR_UNLOCK_CODE_LENGTH = 4;
export const TERMINAL_V2_UNIQUE_LOGIN_CODE_LENGTH = 6;
export const TERMINAL_V2_USER_CARD_CODE_MIN_LENGTH = 1;
export const TERMINAL_V2_USER_CARD_CODE_MAX_LENGTH = 255;

export type TerminalV2ResponseData = V1AuthLogin & {
  terminal: V1AuthTerminal;
};

export type TerminalV2User = {
  name: string;
  uuid: string;
};

export type TerminalV2CheckUserResponse = {
  user_uuid: string;
  full_name: string;
  current_attendance_type: TERMINAL_V2_ATTENDANCE_TYPE;
  available_breaks: TerminalV2UserBreakOption[];
};

export type TerminalV2UserBreakOption = {
  uuid: string;
  display_name: string;
  is_end_of_shift: boolean;
};

export type TerminalV2UserClockInOutResponse = {
  uuid: string;
  start_time: string;
  end_time: string;
  status: ATTENDANCE_EVENT_STATUS;
  type: TERMINAL_V2_ATTENDANCE_TYPE;
  attendance_segment: TerminalV2UserClockInOutResponseAttendanceSegment;
  break_type: string;
};

export type TerminalV2UserClockInOutResponseAttendanceSegment = {
  uuid: string;
  start_time: string;
  end_time: string;
  to_date_balance: number;
};
